import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {HttpModule} from '@angular/http';
import {FormsModule} from '@angular/forms';
import { RouterModule } from "@angular/router";
import {TopnavbarComponent} from "./topnavbar.component";
import { TimerModule } from "../timer/timer.module";
import { Ng2Bs3ModalModule } from "../../../../../node_modules/ng2-bs3-modal/ng2-bs3-modal";
import { ShowHideInput, ShowHideInput2 } from "../../../views/register/show-hide-input.directive";
import { ShowHideInputCam, ShowHideInputCam2, ShowHideInputCam3 } from "./topnavbar.showhide";

@NgModule({
    declarations: [TopnavbarComponent,ShowHideInputCam,ShowHideInputCam2, ShowHideInputCam3],
    imports     : [BrowserModule,RouterModule,HttpModule,FormsModule, TimerModule, Ng2Bs3ModalModule],
    exports     : [TopnavbarComponent],
})

export class TopnavbarModule {}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/topnavbar/topnavbar.module.ts